<div class="box-progress">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading progress...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <p class="error-message">{{ error }}</p>
    <button (click)="reload()" class="retry-button">Retry</button>
  </div>

  <!-- Progress Steps -->
  <div *ngIf="!isLoading && !error && steps.length > 0" class="progress-stepper-container">
    <div class="stepper-wrapper">
      <div
        *ngFor="let step of steps; let i = index"
        class="stepper-item"
        [ngClass]="getStepStatusClass(step)">

        <div class="step-counter" [ngClass]="{'pending': isStepPending(step)}">
          <!-- Completed Step -->
          <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>

          <!-- Active Step -->
          <span *ngIf="isStepActive(step)" class="step-number"></span>

          <!-- Pending Step -->
          <span *ngIf="isStepPending(step)" class=""></span>
        </div>

        <div class="step-name">
          <h6>{{ step.subtitle }}</h6>
          <p>{{ step.title }}</p>
          <span class="status" [ngClass]="getStatusTextClass(step)">
            {{ getStatusDisplayText(step) }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && !error && steps.length === 0" class="empty-state">
    <p>No progress steps available</p>
  </div>
</div>
